import classNames from 'classnames'

const Pager = ({ isDisabled, isChevron, onClick, children }) => {
  let options = {
    class: classNames(
      `control-pagination--pager-item`,
      isDisabled ? 'disabled' : null,
      isChevron ? 'chevron' : null
    ),
    onClick: !isDisabled ? onClick : null
  }
  return <div {...options} >{children}</div>
}

export default Pager
